
<div class="app-header">
  <div class="app-header__content">
    <!-- Logo -->
    <div class="app-header__logo">
      <img
        :src="activeLogo"
        :alt="logoAlt"
        class="app-header__logo-image"
      />
    </div>

    <!-- Center Search Section -->
    <div v-if="showSearch || $slots.search" class="app-header__search">
      <slot name="search">
        <v-autocomplete
          v-model="searchValue"
          :items="searchItems"
          :loading="searchLoading"
          :search-input.sync="searchQuery"
          :placeholder="searchPlaceholder"
          :item-text="searchItemText"
          :item-value="searchItemValue"
          :filter="filterSearchItems"
          return-object
          hide-details
          dense
          outlined
          clearable
          prepend-inner-icon="mdi-magnify"
          class="app-header__search-input"
          :menu-props="{ maxHeight: 400, contentClass: 'app-header__search-menu' }"
          @input="handleSearchSelect"
          @update:search-input="handleSearchInput"
        >
          <template #no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="text-body-2 grey--text">
                  No pages found
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template #item="{ item }">
            <slot name="search-item" :item="item">
              <v-list-item-content>
                <v-list-item-title class="text-body-2">
                  {{ item[searchItemText] || item.text || item.label }}
                </v-list-item-title>
                <v-list-item-subtitle v-if="item.section || item.category" class="text-caption">
                  {{ item.section || item.category }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </slot>
          </template>
        </v-autocomplete>
      </slot>
    </div>

    <!-- Header Actions -->
    <div class="app-header__actions">
      <!-- Product Switcher -->
      <product-switcher
        v-if="showProductSwitcher && products.length > 0"
        :products="products"
        @product-click="handleProductClick"
      />

      <!-- User Menu -->
      <v-menu
        offset-y
        left
        nudge-bottom="8"
        content-class="app-header__user-menu-dropdown"
      >
        <template #activator="{ on, attrs, value }">
          <button
            class="app-header__user-menu-btn"
            aria-label="User menu"
            :aria-haspopup="true"
            :aria-expanded="value ? 'true' : 'false'"
            v-bind="attrs"
            v-on="on"
          >
            <span class="app-header__user-initials" :style="avatarStyle">
              <img
                v-if="userAvatar && !avatarError"
                :src="userAvatar"
                :alt="`Avatar for ${userName}`"
                @error="avatarError = true"
              />
              <span v-else>{{ userInitials }}</span>
            </span>
            <span class="app-header__user-name">{{ userName }}</span>
            <lucide-icon name="ChevronDown" :size="16" class="app-header__user-chevron" aria-hidden="true" />
          </button>
        </template>
        <v-list dense class="app-header__user-menu-list">
          <template v-for="(item, index) in userMenuItems">
            <v-divider
              v-if="item.divider"
              :key="`divider-${index}`"
              class="app-header__user-menu-divider"
            />
            <v-list-item
              v-else
              :key="index"
              class="app-header__user-menu-item"
              @click="handleUserMenuClick(item)"
            >
              <v-list-item-icon v-if="item.icon" class="mr-3">
                <lucide-icon :name="item.icon" :size="18" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-body-2">{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </div>
  </div>
</div>
